import React from 'react'
import { useLocation, Link } from 'react-router-dom';

const LinkContainer = ({Icon, title, to}) => {
  const { pathname } = useLocation();

  return (
    <>
        <Link to={to} className={` transition-all  mb-2 rounded-[6px] group flex space-x-3 py-3 px-4 items-center justify-start`}>
            <Icon className={`transition-all flex-shrink-0  group-hover:text-primary text-xl ${pathname === to ? "text-primary" : "text-t-light"}`} />
            <span className={`transition-all text-sm font-medium  group-hover:text-primary  ${pathname === to ? "text-primary font-semibold" : "text-t-light"}`}>
              {
                title
              }
            </span>
      </Link>
    </>
  )
}

export default LinkContainer